import { rateLimitSelector, setRateLimited } from "@redux/rateLimit"
import { differenceInSeconds } from "date-fns"
import { Button, Container, Modal } from "react-bootstrap"
import toast from "react-hot-toast"
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from "react-redux"

function isStillRateLimited(rateLimitedUntil: number | null) {
	return !!rateLimitedUntil && rateLimitedUntil > Date.now()
}

export const RateLimitedModal = () => {
	const { t } = useTranslation()
	const dispatch = useDispatch()
	const { rateLimitedUntil } = useSelector(rateLimitSelector)

	const retry = () => {
		if (!isStillRateLimited(rateLimitedUntil)) {
			dispatch(setRateLimited(null)) // reset ratelimit
			window.location.reload()
		} else {
			toast.error(t(`Ole hyvä ja odota vielä ${differenceInSeconds(new Date(rateLimitedUntil!), new Date())} sekuntia`))
		}
	}

	return (
		<Modal show={isStillRateLimited(rateLimitedUntil)} fullscreen>
			<Modal.Body>
				<Container className="d-flex flex-column gap-2 h-50 justify-content-center align-items-center">
					<h1 className="text-center">{t("Olet saavuttanut väliaikaisen käyttörajan.")}</h1>
					<h4 className="text-center">{t("Odota hetki ja yritä uudelleen.")}</h4>
					<Button onClick={retry}>{t("Yritä uudelleen")}</Button>
				</Container>
			</Modal.Body>
		</Modal>
	)
}
